import { DateTime } from 'luxon';
import { CoreItem, CoreItemBackend, CoreItemType, VertexRelation } from '../core-item/core-item';
import { SortKeyUtils } from '../core-item/sort-key';
import { UserClerk } from '../user/user-clerk';
import { WorkspaceComboBackend } from '../workspace/workspace';
import { UserBoardConfigBackend } from './user-board-config';

export interface Board extends CoreItem {
  type: BoardType;
  userBoardConfig?: UserBoardConfigBackend;
  unsafeSubData?: BoardUnsafeSubData;
  privateSubData?: BoardPrivateSubData;
}

export interface BoardPrivateSubData {
  unipile?: {
    accountId?: string;
  };
}

export interface BoardUnsafeSubData {
  backgroundColor?: string;
}

export interface BoardBackend extends CoreItemBackend {
  type: BoardType;

  timezone?: string;
  userBoardConfig?: UserBoardConfigBackend;

  pinnedBoardIdList?: string[];

  workspaceBackend?: WorkspaceComboBackend;

  relationBackendList?: VertexRelation[];
  itemBackendList?: CoreItemBackend[];

  unsafeSubData?: BoardUnsafeSubData;
  privateSubData?: BoardPrivateSubData;
}

export enum BoardType {
  personal = 'personal',
  team = 'team',
  project = 'project',
  workpage = 'workpage',
  tag = 'tag',
  customer = 'customer',
}

export function getNewPersonalBoardMetadataList(
  user: UserClerk,
  workspaceId: string,
  boardId?: string
): {
  type: CoreItemType;
  metadata: Partial<CoreItemBackend>;
}[] {
  let preferredName;

  preferredName = user.firstName;

  const primaryEmail = user?.emailAddresses?.find((email) => email.id === user?.primaryEmailAddressId);

  if (!preferredName) {
    preferredName = primaryEmail?.emailAddress?.split('@')[0];

    if (!preferredName) {
      preferredName = 'Change Your Name';
    }
  }

  const tempBoard = {
    id: boardId,
    sk: SortKeyUtils.getSortKey({ type: CoreItemType.board, createdDate: DateTime.utc() }),
    ws: workspaceId,
    type: BoardType.personal,
    userBoardConfig: {
      userId: user.id,
      email: primaryEmail?.emailAddress,
      preferredName,
      lastName: user?.lastName,
      portraitUrl: user?.imageUrl,
    },
  };

  const addMetadataList = [{ type: CoreItemType.board, metadata: tempBoard as any }];
  return addMetadataList;
}
